var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPaymentStatusWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 51,
  height: 50,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 25,
  r: 23.5,
  stroke: "#4264FD",
  strokeWidth: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4264FD",
  d: "M24.464 13.878a2.9 2.9 0 0 1 2.13-.878q1.269 0 2.128.878.882.877.881 2.121 0 1.245-.88 2.123a2.9 2.9 0 0 1-2.13.878q-1.228 0-2.11-.878a2.89 2.89 0 0 1-.88-2.123q0-1.244.86-2.121M29.41 20c-2.458.363-4.91.549-7.37.892l-.253 1.125c.262-.012.486-.004.672-.004q.615 0 .97.324.355.325.355.745c0 .445-.124.657-.373 1.535l-2.594 9.126q-.317 1.088-.317 1.794 0 1.07.709 1.775c.485.459 2.003.688 2.811.688 2.114 0 5.602-1.155 7.48-4.502l-1.51-.9c-.784 1.234-2.199 2.126-2.846 2.528-.698.34-1.078.316-1.29.316q-.186 0-.354-.172a.6.6 0 0 1-.168-.4q0-.363.317-1.528z"
})));
export default SvgIconPaymentStatusWarning;